import React from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  // This effect will run once the user is redirected back from Cognito
  React.useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      // Once authenticated, redirect to the dashboard
      navigate('/'); 
    } else if (!auth.isLoading && auth.error) {
      // Handle authentication errors
      navigate('/login-error'); // You can create an error page if you want
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  return <div>Loading...</div>;
};

export default AuthCallback;